import { createSelector } from 'reselect';

import type { IApplicationState } from 'shared/types/redux';

import { getCurrentTab } from './getCurrentTab';

export const getCurrentTabState = createSelector(
  (state: IApplicationState) => state,
  getCurrentTab,
  (state, tab) => state[tab],
);
